import { withAssetPrefix } from "gatsby";
import React from "react";
import { EmbeddedAsset } from "../../../graphql-types";

type Props = {
  asset: EmbeddedAsset;
};

export function EmbeddedVideo({ asset: { file } }: Props) {
  return (
    <video
      className="w-full"
      controls
      poster={withAssetPrefix(
        file.fileLocal?.videoH264?.screenshots?.[0]?.path as string
      )}
      preload="none"
    >
      <source
        src={withAssetPrefix(file.fileLocal?.videoH264?.path as string)}
        type="video/mp4"
      />
    </video>
  );
}
